﻿(function($) {

	$.widget('lb.hoverhelper', {
		options: {
			activeSelector: '.sel',
			css: [],
			height: 2,
			hoverElement: '.hover-helper',
			hoverClass: '',
			itemSelector: 'li',
			speed: 300,
			vertical: false,
			alwaysVisible: true
		},
		_hover: function(elem, helper) {
			var loc = elem.data('hoverhelper-location');
			elem.addClass(this.options.hoverClass).siblings().removeClass(this.options.hoverClass);
				
			// Calculate location if we have not done that before
			if (!loc && this.element.is(':visible')) {
				if (this.options.vertical) {
					loc = {
						top: elem.position().top,
						height: elem.outerHeight()
					};
				} else {
					loc = {
						left: elem.position().left,
						width: elem.outerWidth()
					};
				}

				// Animate more css properties
				var css = this.options.css;
				for (var i = 0; i < css.length; i++) {
					loc[css[i]] = elem.data(css[i]);
				}
				// Cache our result
				elem.data('hoverhelper-location', loc);
			}

			// Stop current animation and animate
			helper.show().stop().animate(loc, this.options.speed);
			helper[elem.closest(this.options.itemSelector).is(":last-child") ? "addClass" : "removeClass"]("last-child");
		},
		_create: function() {
			var helper = this.element.find(this.options.hoverElement),
				that = this;

			if (!helper.length) {
				helper = $('<div class="hover-helper"></div>');
				if (this.element.hasClass('simple')) {
					helper.addClass('simple');
				}
				this.element.append(helper);
			}

			helper.css({
				position: 'absolute',
				height: this.options.height + 'px'
			}).hide();

			var items = this.element.find(this.options.itemSelector).bind('mouseover', function() {
				that._hover($(this), helper);
			});

			if (that.options.alwaysVisible) {
				var active = items.filter(this.options.activeSelector);
				if (active.length) {
					this._hover(active, helper);
				}

				this.element.bind('mouseleave', function() {
					// Hover the selected on mouse leave
					that._hover($(this).find(that.options.activeSelector), helper);
				});
			} else {
				this.element.bind("mouseleave", function() {
					helper.hide();
					items.removeClass(that.options.hoverClass);
				});
			}
		},
		_destroy: function() {
		},
		update: function() {
			var helper = this.element.find(this.options.hoverElement);
			var active = this.element.find(this.options.itemSelector).filter(this.options.activeSelector);
			
			if (active.length) {
				this._hover(active, helper);
			}
		}
	});

})(jQuery);